export default class Reservation {
    constructor(titles, contents, callToActions, files, image, form, storeLinks) {
        // Multilanguage
        this.titles = titles;
        this.contents = contents;
        this.callToActions = callToActions;
        // Array
        this.files = files;
        // Object
        this.image = image;
        this.form = form;
        this.storeLinks = storeLinks;
    }

    isValid() {
        var result = true;

        for (const [key, value] of Object.entries(this.titles)) { if(!value) { result = false; break; }; }
        for (const [key, value] of Object.entries(this.contents)) { if(!value) { result = false; break; }; }
        for (const [key, value] of Object.entries(this.callToActions)) { if(!value) { result = false; break; }; }

        if(result) result = this.image;

        return result;
    }
}